import React from 'react';
import { Divider } from '@kambi/spark';

import Description from 'components/landing/description/Description';
import UtilsList from 'components/layout/utils-list/UtilsList';
import classes from './Landing.module.css';

const Landing = () => {
    const utils = [
        {
            label: 'Outcome label',
            path: 'label/outcome',
        },
        {
            label: 'Bet Offer label',
            path: 'label/betOffer',
        },
        {
            label: 'Potential Payout',
            path: 'potential-payout',
        },
        {
            label: 'Currency Display',
            path: 'currency-display',
        },
        {
            label: 'Odds helpers',
            path: 'odds',
        },
        {
            label: 'System combinations',
            path: 'system/combinations',
        },
    ];
    return (
        <div className={classes.Landing}>
            <Description />
            <Divider />
            <UtilsList props={utils} />
        </div>
    );
};

export default Landing;
